import { motion } from "motion/react";
import type { Disclosure } from "../../hooks";
import { Icon } from "../../icons";
import { cn } from "../../utils";

/** Props Interface */
interface SidebarNavigationLabelProps {
	label: string;
	disclosure?: Disclosure;
}

export function SidebarNavigationLabel({ label, disclosure }: SidebarNavigationLabelProps) {
	/** Computed */
	const hasDisclosure = !!disclosure;

	const Component = hasDisclosure ? "button" : "div";

	/** Render */
	return (
		<Component
			className={cn("px-4 h-stack w-full justify-between", hasDisclosure && "cursor-pointer")}
			type="button"
			onClick={disclosure?.onToggle}
		>
			<p className="font-medium opacity-50 text-xs">{label}</p>
			{disclosure && (
				<motion.div animate={{ rotate: disclosure.isOpen ? 0 : 90 }}>
					<Icon name="ChevronDown" />
				</motion.div>
			)}
		</Component>
	);
}
